import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface IExerciseOptionsFilterProps {
  formik: FormikProps<any>;
  filterTypeOptions: Array<{ id: string; name: string }>;
  filterDefaultOptions: Array<{ id: string | boolean; name: string }>;
  filterActiveOptions: Array<{ id: string | boolean; name: string }>;
}

export function ExerciseOptionsFilter(props: IExerciseOptionsFilterProps) {
  const {
    formik,
    filterTypeOptions,
    filterDefaultOptions,
    filterActiveOptions,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.type')}
          name="type"
          options={filterTypeOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.default')}
          name="default"
          options={filterDefaultOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="active"
          options={filterActiveOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
